import { render, staticRenderFns } from "./AffiliateRecipes.vue?vue&type=template&id=3a1159c8&scoped=true&"
import script from "./AffiliateRecipes.vue?vue&type=script&lang=js&"
export * from "./AffiliateRecipes.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateRecipes.vue?vue&type=style&index=0&id=3a1159c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1159c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow})
